import { sm4Encrypt, sm4Decrypt, getSM4Key } from './sm4-utils'
import { sm2Encrypt, sm2Decrypt, sm2DoSignature, sm2DoVerifySignature } from './sm2-utils'
import { timeStamp, guid, sign } from './Encrypt'
//import { USER_INFO } from '@/store/mutation-types'
const encoding = require('text-encoding')
window.TextEncoder = encoding.TextEncoder
window.TextDecoder = encoding.TextDecoder

const sm3 = require('sm-crypto').sm3
const cipherMode = 1
/*
publicKey  解密验签用
usersignprivateKey  加密签名用
privateKey 加密
userdeprivateKey 解密
*/
const publicKey = '04834b38bb7ff1d895d573dfa7c3038b86788129c9117b5ca23ef21ba0e281a3253aca660d48108b71a7e183d6d00adb6f4bbc6260d5729944143853bef8fb5505'
const privateKey = '046c57c27cbb1235a8a153d646681b5d720cdc92c0c84ee65734a8e3d875b1b6a44ac5c805a1b38f86c518854dd0c102e879f96558f435f35157032598b1a6cf6b' // 加密
// 验签用公钥，加密用公钥

const usersignprivateKey = '00884cc0b49441f92054f8162f26a5524b0de8c209159fea37fcddd70d6828578b'
const userdeprivateKey = '0084087e7795495293d98adfdeba977930da416f6a5000d50a88b1de78ab963114' // 解密

export const getRaw = (response) => {
    let resSign = Object.assign({}, response.data)
    delete resSign['sign']

    resSign = sign(resSign)

    let str = JSON.stringify(resSign)
    str = str.replace(/[{}"]/g, '').replace(/:/g, '=').replace(/,/g, '&')
    str = str.replace(/####/g, ':')
    str = sm3(str)
    let signStr = response.sign
    if (response.data) {
        signStr = response.data.sign
    }

    const checkSign = sm2DoVerifySignature(str, signStr, publicKey)
    if (checkSign) {
        // 获取密钥
        const encodeKey = response.data.encodeKey.slice(2)
        const sm4deKey = sm2Decrypt(encodeKey.toLocaleLowerCase(), userdeprivateKey, cipherMode)
        //  responseData更换为encryptRespData
        const res = JSON.parse(sm4Decrypt(response.data.encryptRespData, sm4deKey)) // sm4解密
        response.data = res
        return res
    }
}

export const getImgRaw = (response) => {
    let resSign = Object.assign({}, response)
    delete resSign['sign']
    resSign = sign(resSign)

    let str = JSON.stringify(resSign)
    str = str.replace(/[{}"]/g, '').replace(/:/g, '=').replace(/,/g, '&')
    str = str.replace(/####/g, ':')
    str = sm3(str)

    const checkSign = sm2DoVerifySignature(str, response.sign, publicKey)
    if (checkSign) {
        // 获取密钥
        const encodeKey = response.encodeKey.slice(2)
        const sm4deKey = sm2Decrypt(encodeKey.toLocaleLowerCase(), userdeprivateKey, cipherMode)
        //  responseData更换为encryptRespData
        const res = JSON.parse(sm4Decrypt(response.encryptRespData, sm4deKey)) // sm4解密
        response = res
        return res
    }
}

export const addSM = (config) => {
    const sm4Key = getSM4Key()
    let encryptdata = ''
    // 鉴权结束
    const data = config.data
    encryptdata = sm4Encrypt(JSON.stringify(data), sm4Key)

    config.data = {} // 赋值为空
    config.data.requestData = encryptdata // 加密数据
    config.data.timeStamp = timeStamp// .replace(/:/g, '####')
    config.data.requestId = guid
    config.data.encryptAlgo = 'SM4'
    config.data.version = '1.0.0'
    config.data.encodeKey = `04${sm2Encrypt(sm4Key, privateKey, cipherMode)}`
    config.data.timeStamp = config.data.timeStamp.replace(/:/g, '####')
    let str = JSON.stringify(sign(config.data))
    str = str.replace(/[{}"]/g, '').replace(/:/g, '=').replace(/,/g, '&')
    str = str.replace(/####/g, ':')
    str = sm3(str)

    config.data.sign = sm2DoSignature(str, usersignprivateKey)
    config.data.timeStamp = config.data.timeStamp.replace(/####/g, ':')
}
